import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { CustomBusiness } from '@/models/custom-business.model';
import { CustomResponse } from '@/models/custom-response.model';
import { BusinessService } from '@/services';
import { BUSINESS, PERMISSIONS } from '@/constants';

const Notification = namespace('notification');
const Authentication = namespace('authentication');

@Component({
    components: { },
})
export default class BusinessEditView extends Vue {
    @Authentication.Getter('hasPermission') private hasPermission: (permission: string) => boolean;
    @Notification.Action('addSuccess') private addSuccess: any;
    @Notification.Action('addError') private addError: any;

    public inFlight: boolean = false;
    public editBusiness: CustomBusiness = new CustomBusiness();
    public confirmDelete: boolean = false;

    public mounted() {
        const id = parseInt(this.$route.params.id, 10);
        this.getData(id);
    }

    private async getData(id: number) {
        this.inFlight = true;
        try {
            const response = await BusinessService.get(id);
            this.editBusiness = response.data;
            this.inFlight = false;
        } catch (error) {
            this.addError(error.localized, error);
            this.inFlight = false;
        }
    }

    public handleSubmit(): void {
        BusinessService.update(this.editBusiness).then(
            (response: CustomResponse<CustomBusiness>) => {
                this.editBusiness = response.data;
                this.addSuccess(response.localized);
            },
            (error: CustomResponse<any>) => {
                this.addError(error.localized, error);
            },
        );
    }

    public remove(id: number): void {
        BusinessService.remove(id).then(
            (response: CustomResponse<any>) => {
                this.addSuccess(response.localized);
                this.$router.push({ name: 'businessList' });
            },
            (error: CustomResponse<any>) => {
                this.addError(error.localized, error);
            },
        );
    }

    public getTypeOptions(): any[] {
        return BUSINESS.TYPE_OPTIONS.map((option: string) => {
            return {
                label: this.$t('modules.businessManagement.attributes.type.options.' + option),
                value: option,
            };
        });
    }

    public getStatusCssClasses() {
        if (this.editBusiness.confirmed && this.editBusiness.approved) {
            return { 'status-indicator': true, 'bg-success': true };
        } else if (this.editBusiness.confirmed && !this.editBusiness.approved) {
            return { 'status-indicator': true, 'bg-warning': true };
        } else {
            return { 'status-indicator': true, 'bg-danger': true };
        }
    }

    public canApprove(): boolean {
        return this.hasPermission(PERMISSIONS.Business.PATCH);
    }

    public resendConfirmation(id) {
        BusinessService.resendConfirmation(id).then(
            (response: CustomResponse<any>) => {
                this.addSuccess(response.localized);
            },
            (error: CustomResponse<any>) => {
                this.addError(error.localized, error);
            },
        );
    }

    public setStatus(approved) {
        BusinessService.approve(this.editBusiness.id, approved).then(
            (response: CustomResponse<CustomBusiness>) => {
                this.editBusiness = response.data;
                this.addSuccess(response.localized);
            },
            (error: CustomResponse<any>) => {
                this.addError(error.localized, error);
            },
        );
    }
}
